import { EMPTY_FUNCTION } from '../../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'
import { AITextGenerationField } from '../../../AITextGenerationField'
import { FormikForm } from '../../../Formik'
import { TextareaOutlineField } from '../../../Textarea'

const DEMO_FIELD_NAME = 'message'

const DEMO_INITIAL_VALUES = {
  [DEMO_FIELD_NAME]: FORMIK_EMPTY_VALUE,
}

function AITextGenerationFieldLibrary() {
  return (
    <FormikForm initialValues={DEMO_INITIAL_VALUES} onSubmit={EMPTY_FUNCTION}>
      <AITextGenerationField fieldName={DEMO_FIELD_NAME}>
        <TextareaOutlineField
          autoResizeHeight
          label='Message'
          name={DEMO_FIELD_NAME}
        />
      </AITextGenerationField>
    </FormikForm>
  )
}

export default AITextGenerationFieldLibrary
